export const ENV_PROD: string = 'prod';
export const ENV_PREPROD: string = 'preprod';
export const ENV_DEV: string = 'development';
export const ENV_PLAYWRIGHT: string = 'playwright';
